export default __webpack_public_path__ + "static/media/scenario-designer-api-bg.dc504a3a.png";